<template>
  <div>
      <div v-if="vc_data.ut=='Employee'">
          <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
              <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
              <v-btn dark text @click="snackbar = false">Close</v-btn>
          </v-snackbar>
          <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <!-- begin                                                                         -->
          <!-- <center>Coming soon, stay tuned!!!</center> -->
          <!-- <template>
    VC:{{ vc_data }}
    <br />
    Org:{{ org_basic_data }}
  </template> -->

          <!-- virtual icard code -->
          <v-row dense class="main-row">
              <v-col md="2"></v-col>
              <v-col cols="12" sm="12" md="9">
                  <div class="container">
                      <div class="icard">
                          <v-row dense>
                              <v-col cols="3" sm="3" md="3">
                                  <!-- School logo -->

                                  <img class="trust-logo" :src="org_basic_data.trust_logo" /><br />
                              </v-col>
                              <v-col cols="9" sm="9" md="9">
                                  <center>
                                      <h2>{{ org_basic_data.trust_name }}</h2>

                                      <h1>{{ org_basic_data.school_name }}</h1>

                                      <!-- <span>{{ org_basic_data.address }}</span
                ><br /> -->
                                  </center>
                                  <!-- <template v-if="org_basic_data.line1 != null">
                <center>
                  <span v-html="org_basic_data.line1"></span><br />
                  <span v-html="org_basic_data.line2"></span>
                </center>
              </template> -->
                              </v-col>
                          </v-row>

                          <div class="adrs">
                              <!-- <center> -->
                              <span>{{ org_basic_data.address }}</span><br />
                              <template v-if="org_basic_data.line1 != null">
                                  <center>
                                      <span v-html="org_basic_data.line1"></span><br />
                                      <span v-html="org_basic_data.line2"></span>
                                  </center>
                              </template>
                              <span>{{ org_basic_data.phone }}</span>
                              <span>&nbsp;{{ org_basic_data.email }}</span><br />

                              <span><b>Website: &nbsp; &nbsp;{{ org_basic_data.website }}</b></span>
                              <!-- </center> -->
                          </div>
                          <!-- <v-row dense>
            <v-col cols="12" sm="3" md="3"></v-col>
            <v-col cols="12" sm="8" md="8">
             
                <center>
                <span>{{ org_basic_data.phone }}</span>
                <span>&nbsp;{{ org_basic_data.email }}</span
                ><br />

                <span
                  ><b
                    >Website: &nbsp; &nbsp;{{ org_basic_data.website }}</b
                  ></span
                >
                </center>
              
            </v-col>
          </v-row> -->
                          <!-- <v-divider></v-divider> -->
                          <hr style="width: 90%; margin-left: 5%; border: 2px solid grey;" />
                          <br />
                          <div>
                              <center>
                                  <img :src="basepath + vc_data.photo" height="10%" width="30%" alt="logo" v-if="vc_data.photo !== null" />
                              </center>
                          </div>
                          <div>
                              <center>
                                  <span v-if="vc_data.ut == 'Student'">
                                      <span><b> Reg No: {{ vc_data.uid }}</b></span>
                                      <span class="ml-3"><b> Standard: {{ vc_data.learner_std }} </b></span>
                                  </span>
                                  <span v-else-if="vc_data.ut == 'Employee'"><b> Employee Code: {{ vc_data.uid }}</b></span>
                                  <span v-else><b> UID: {{ vc_data.uid }}</b></span>
                                  <br />
                                  <span><b> {{ vc_data.name }} </b></span><br />

                                  <span><b> {{ vc_data.ut }} </b></span>
                              </center>
                          </div>
                          <v-row>
                              <!-- <v-col cols="12" sm="1" md="1"></v-col> -->
                              <v-col xs="12" cols="12" sm="6" md="6">
                                  <center>
                                      <div class="barcode">
                                          <barcode height="50" width="1" font-size="15px" v-model="vc_data.uid" v-bind:value="vc_data.uid"> </barcode>
                                      </div>
                                  </center>
                              </v-col>
                              <v-col xs="12" cols="12" sm="6" md="6">
                                  <center>
                                      <qrcode-vue :value="vc_data.uid" v-if="vc_data.uid" :size="100" level="H" />
                                  </center>
                              </v-col>

                              <!-- <v-col cols="12" sm="3" md="3"></v-col> -->
                          </v-row>
                      </div>
                  </div>
              </v-col>
              <v-col md="1"></v-col>
          </v-row>
          <!-- icard code end -->
      </div>
      <!-- wws virtual icard parent-->
      <!-- {{ vc_data }} -->
      <div style="width: 19rem; margin-left: -10px; background-color: white;" v-if="tenant=='wws'  && vc_data.ut=='Parent'">
          <div class="row" style="height: 115px; background-color: #623e7e; margin-top: -5px; max-width: 316px;">
              <div class="col-1" style="margin-top: 10px;">
                  <img :src="org_basic_data.trust_logo" style="width: 80px; height: 80px; margin-left: 8px;" alt="logo" />
              </div>
              <div class="col-11" style="margin-top: 4px;">
                  <b>
                      <span style="text-transform: uppercase; line-height: 1; color: white; margin-left: 65px; font-family: 'Vogue'; font-size: 14px;">
                          {{ org_basic_data.school_name }}
                      </span>
                  </b>
                  <div style="border-bottom: 1px solid white; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="color: white; margin-left: 65px; font-size: x-small; font-family: 'Roboto Condensed';">{{ org_basic_data.address }}</span>
                  <div style="border-bottom: 1px solid white; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: white; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.website }}</span>
                  <div style="border-bottom: 1px solid white; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: white; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.email }}</span>
                  <div style="border-bottom: 1px solid white; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: white; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.phone }}</span>
              </div>
          </div>
          <div class="row" style="background-color: #f5e8ca; height: 5px; justify-content: center; width: 20rem;"></div>
          <!-- <div class="row" style="justify-content: center; margin-top: 40px;">
                  <span style="font-weight: 500;"> Student Details</span>
              </div> -->
          <div class="row" style="justify-content: center; margin-top: 20px;">
              <div style="margin-right: 15px; width: 6rem;">
                  <span style="position: relative;" v-if="vc_data.student_photo">
                      <center>
                          <span v-if="vc_data.student_photo" style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img v-if="vc_data.student_photo" style="border: 3px solid black;" :src="basepath + vc_data.student_photo" width="100px" height="100px" />
                          <span v-if="vc_data.student_photo" style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span style="position: relative;" v-else>
                      <center>
                          <span style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" alt="" :src="vc_data.student_photo" width="100px" height="100px" />
                          <span style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span class="text-center" v-if="vc_data.name">
                      <h5 style="color: #623e7e; height: 50px; font-size: 11px; line-height: 12px;">
                          {{ vc_data.name }}
                      </h5>
                  </span>
              </div>

              <div style="width: 19rem; margin-top: 5px;">
                  <center>
                      <qrcode-vue style="margin-left: -20px;" :value="vc_data.uid" v-if="vc_data.uid" :size="55" level="H"></qrcode-vue>
                  </center>
              </div>
              <!-- <center>
                  <div class="barcode">
                      <barcode height="50" width="1" font-size="15px" v-model="vc_data.uid" v-bind:value="vc_data.uid"> </barcode>
                  </div>
              </center> -->
          </div>
          <div class="row" style="background-color: #623e7e; height: 15px; position: relative; width: 316px;"></div>
      </div>
      <!-- sbpps vitual icard parent-->
      <div style="width: 19rem; margin-left: -10px; background-color: white;" v-if="tenant=='sbpps' && vc_data.ut=='Parent'">
          <div class="row" style="height: 115px; background-color: #0095cb; margin-top: -5px; max-width: 316px;">
              <div class="col-1" style="margin-top: 10px;">
                  <img :src="org_basic_data.trust_logo" style="width: 80px; height: 80px; margin-left: 8px;" alt="logo" />
              </div>
              <div class="col-11" style="margin-top: 4px;">
                  <b>
                      <!-- <span style="text-transform: uppercase; line-height: 1; color: white; margin-left: 65px;font-family: 'Dosis';font-size: 20px;"> -->
                      <span style="text-transform: uppercase; line-height: 1; color: black; margin-left: 65px; font-family: 'Vogue'; font-size: 14px;">
                          {{ org_basic_data.school_name }}
                          <!-- <br />
                      <span style="margin-left: 65px;"></span> SCHOOL -->
                      </span>
                  </b>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="color: black; margin-left: 65px; font-size: x-small; font-family: 'Roboto Condensed';">{{ org_basic_data.address }}</span>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: black; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.website }}</span>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: black; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.email }}</span>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: black; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.phone }}</span>
              </div>
          </div>
          <div class="row" style="background-color: #f5e8ca; height: 5px; justify-content: center; width: 20rem;"></div>
          <div class="row" style="justify-content: center; margin-top: 40px;">
              <span style="font-weight: 500;"> Parent Details</span>
          </div>
          <div class="row" style="justify-content: center; margin-top: 20px;">
              <div style=" width: 6rem;" v-if="vc_data.father_full_name">
                  <span style="position: relative;" v-if="vc_data.fphoto">
                      <center>
                          <span v-if="vc_data.fphoto" style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img v-if="vc_data.fphoto" style="border: 3px solid black;" :src="vc_data.fphoto" width="100px" height="100px" />
                          <span v-if="vc_data.fphoto" style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span style="position: relative;" v-else>
                      <center>
                          <span style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" alt="" :src="vc_data.fphoto" width="100px" height="100px" />
                          <span style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span class="text-center" v-if="vc_data.father_full_name">
                      <h5 style="color: black; height: 50px; font-size: 11px; line-height: 12px;">
                          {{ vc_data.father_full_name }}
                      </h5>
                  </span>
                  <div class="text-center" style="" v-if="vc_data.father_mobile_no">
                      <h5>
                          <span style="font-weight: 500;"> Contact No. : </span><br />
                          {{ vc_data.father_mobile_no }}
                      </h5>
                  </div>
              </div>
              <div v-if="vc_data.father_full_name && vc_data.mother_full_name" style="border-right: black 1.5px dotted; margin-right: 15px; width: 1rem;"></div>
              <div style="width: 6rem; " v-if="vc_data.mother_full_name">
                  <span style="position: relative;" v-if="vc_data.mphoto">
                      <center>
                          <span v-if="vc_data.mphoto" style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" v-if="vc_data.mphoto" :src="vc_data.mphoto" width="100px" height="100px" />
                          <span v-if="vc_data.mphoto" style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span style="position: relative;" v-else>
                      <center>
                          <span style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" :src="vc_data.mphoto" alt="" width="100px" height="100px" />
                          <span style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span class="text-center" v-if="vc_data.mother_full_name">
                      <h5 style="color: black; height: 50px; font-size: 12px; line-height: 12px;">
                          {{ vc_data.mother_full_name }}
                      </h5>
                  </span>

                  <div class="text-center" v-if="vc_data.mother_mobile_no">
                      <h5>
                          <span style="font-weight: 500;"> Contact No. : </span><br />
                          {{ vc_data.mother_mobile_no}}
                      </h5>
                  </div>
              </div>
              <div class="row" style="width: 20rem; justify-content: center;margin-top: 5px;margin-bottom: 5px;">
              
                  <center>
                      <qrcode-vue  :value="vc_data.uid" v-if="vc_data.uid" :size="55" level="H"></qrcode-vue>
                  </center>
             
            </div>
              <!-- <center>
                      <div class="barcode">
                          <barcode height="50" width="1" font-size="15px" v-model="vc_data.uid" v-bind:value="vc_data.uid"> </barcode>
                      </div>
                  </center> -->
                  
          </div>
          <div class="row" style="background-color: #0095cb; height: 15px; position: relative; width: 316px;"></div>
      </div>
      <!-- zeal virtual icard parent-->
      <div style="width: 19rem; margin-left: -10px; background-color: white;" v-if="tenant=='zeal'  && vc_data.ut=='Parent'">
          <div class="row" style="height: 115px; background-color: white; margin-top: -5px; max-width: 316px;">
              <div class="col-1" style="margin-top: 10px;">
                  <img :src="org_basic_data.trust_logo" style="width: 80px; height: 80px; margin-left: 8px;" alt="logo" />
              </div>
              <div class="col-11" style="margin-top: 4px;">
                  <b>
                      <span style="text-transform: uppercase; white-space: nowrap; line-height: 1; color: black; margin-left: 65px; font-family: 'Vogue'; font-size: 10px;">
                          {{ org_basic_data.school_name }}
                      </span>
                  </b>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="color: black; margin-left: 65px; white-space: nowrap; font-size: 8px; font-family: 'Roboto Condensed';">{{ org_basic_data.address }}</span>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: black; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.website }}</span>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: black; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.email }}</span>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: black; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.phone }}</span>
              </div>
          </div>
          <div class="row" style="background-color: #f5e8ca; height: 5px; justify-content: center; width: 20rem;"></div>
          <div class="row" style="justify-content: center; margin-top: 40px;">
              <span style="font-weight: 500;"> Parent Details</span>
          </div>
          <div class="row" style="justify-content: center; margin-top: 20px;">
              <div style="width: 6rem;" v-if="vc_data.father_full_name">
                  <span style="position: relative;" v-if="vc_data.fphoto">
                      <center>
                          <span v-if="vc_data.fphoto" style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img v-if="vc_data.fphoto" style="border: 3px solid black;" :src="vc_data.fphoto" width="100px" height="100px" />
                          <span v-if="vc_data.fphoto" style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span style="position: relative;" v-else>
                      <center>
                          <span style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" alt="" :src="vc_data.fphoto" width="100px" height="100px" />
                          <span style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span class="text-center" v-if="vc_data.father_full_name">
                      <h5 style="color: black; height: 50px; font-size: 11px; line-height: 12px;">
                          {{ vc_data.father_full_name }}
                      </h5>
                  </span>
                  <div class="text-center" style="" v-if="vc_data.father_mobile_no">
                      <h5>
                          <span style="font-weight: 500;"> Contact No. : </span><br />
                          {{ vc_data.father_mobile_no }}
                      </h5>
                  </div>
              </div>
              <div v-if="vc_data.father_full_name && vc_data.mother_full_name" style="border-right: black 1.5px dotted; margin-right: 15px; width: 1rem;"></div>
              <div style="width: 6rem;" v-if="vc_data.mother_full_name">
                  <span style="position: relative;" v-if="vc_data.mphoto">
                      <center>
                          <span v-if="vc_data.mphoto" style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" v-if="vc_data.mphoto" :src="vc_data.mphoto" width="100px" height="100px" />
                          <span v-if="vc_data.mphoto" style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span style="position: relative;" v-else>
                      <center>
                          <span style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" :src="vc_data.mphoto" alt="" width="100px" height="100px" />
                          <span style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span class="text-center" v-if="vc_data.mother_full_name">
                      <h5 style="color: black; height: 50px; font-size: 12px; line-height: 12px;">
                          {{ vc_data.mother_full_name }}
                      </h5>
                  </span>

                  <div class="text-center" v-if="vc_data.mother_mobile_no">
                      <h5>
                          <span style="font-weight: 500;"> Contact No. : </span><br />
                          {{ vc_data.mother_mobile_no}}
                      </h5>
                  </div>
              </div>
              <div class="row" style="width: 20rem; justify-content: center; margin-top: 5px; margin-bottom: 5px;">
                  <center>
                      <qrcode-vue  :value="vc_data.uid" v-if="vc_data.uid" :size="55" level="H"></qrcode-vue>
                  </center>
              </div>
              <!-- <center>
                      <div class="barcode">
                          <barcode height="50" width="1" font-size="15px" v-model="vc_data.uid" v-bind:value="vc_data.uid"> </barcode>
                      </div>
                  </center> -->
          </div>
          <div class="row" style="background-color: white; height: 15px; position: relative; width: 316px;"></div>
      </div>
      <!-- sanjivani virtual icard parent-->
      <div style="width: 19rem; margin-left: -10px; background-color: white;" v-if="tenant=='sanjivani'  && vc_data.ut=='Parent'">
          <div class="row" style="height: 115px; background-color: white; margin-top: -5px; max-width: 316px;">
              <div class="col-1" style="margin-top: 10px;">
                  <img :src="org_basic_data.school_logo" style="width: 80px; height: 80px; margin-left: 8px;" alt="logo" />
              </div>
              <div class="col-11" style="margin-top: 4px;">
                  <b>
                      <span style="text-transform: uppercase; white-space: nowrap; line-height: 1; color: black; margin-left: 65px; font-family: 'Vogue'; font-size: 10px;">
                          {{ org_basic_data.school_name }}
                      </span>
                  </b>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="color: black; margin-left: 65px; white-space: nowrap; font-size: 8px; font-family: 'Roboto Condensed';">{{ org_basic_data.address }}</span>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: black; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.website }}</span>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: black; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.email }}</span>
                  <div style="border-bottom: 1px solid black; width: 80%; margin-left: 65px; margin-bottom: -5px;"></div>
                  <span style="margin-left: 65px; color: black; font-size: 11px; font-family: 'Roboto Condensed';">{{ org_basic_data.phone }}</span>
              </div>
          </div>
          <div class="row" style="background-color: #f5e8ca; height: 5px; justify-content: center; width: 20rem;"></div>
          <div class="row" style="justify-content: center; margin-top: 40px;">
              <span style="font-weight: 500;"> Parent Details</span>
          </div>
          <div class="row" style="justify-content: center; margin-top: 20px;">
              <div style="width: 6rem;" v-if="vc_data.father_full_name">
                  <span style="position: relative;" v-if="vc_data.fphoto">
                      <center>
                          <span v-if="vc_data.fphoto" style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img v-if="vc_data.fphoto" style="border: 3px solid black;" :src="vc_data.fphoto" width="100px" height="100px" />
                          <span v-if="vc_data.fphoto" style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span style="position: relative;" v-else>
                      <center>
                          <span style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" alt="" :src="vc_data.fphoto" width="100px" height="100px" />
                          <span style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span class="text-center" v-if="vc_data.father_full_name">
                      <h5 style="color: black; height: 50px; font-size: 11px; line-height: 12px;">
                          {{ vc_data.father_full_name }}
                      </h5>
                  </span>
                  <div class="text-center" style="" v-if="vc_data.father_mobile_no">
                      <h5>
                          <span style="font-weight: 500;"> Contact No. : </span><br />
                          {{ vc_data.father_mobile_no }}
                      </h5>
                  </div>
              </div>
              <div v-if="vc_data.father_full_name && vc_data.mother_full_name" style="border-right: black 1.5px dotted; margin-right: 15px; width: 1rem;"></div>
              <div style="width: 6rem;" v-if="vc_data.mother_full_name">
                  <span style="position: relative;" v-if="vc_data.mphoto">
                      <center>
                          <span v-if="vc_data.mphoto" style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" v-if="vc_data.mphoto" :src="vc_data.mphoto" width="100px" height="100px" />
                          <span v-if="vc_data.mphoto" style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span style="position: relative;" v-else>
                      <center>
                          <span style="position: absolute; border-top: 5px solid #f5e8ca; border-left: 5px solid #f5e8ca; width: 35px; height: 35px; top: -5px; left: -5px;"></span>
                          <img style="border: 3px solid black;" :src="vc_data.mphoto" alt="" width="100px" height="100px" />
                          <span style="position: absolute; border-right: 5px solid #f5e8ca; border-bottom: 5px solid #f5e8ca; width: 35px; height: 35px; bottom: 4.4px; right: -10%;"></span>
                      </center>
                  </span>
                  <span class="text-center" v-if="vc_data.mother_full_name">
                      <h5 style="color: black; height: 50px; font-size: 12px; line-height: 12px;">
                          {{ vc_data.mother_full_name }}
                      </h5>
                  </span>

                  <div class="text-center" v-if="vc_data.mother_mobile_no">
                      <h5>
                          <span style="font-weight: 500;"> Contact No. : </span><br />
                          {{ vc_data.mother_mobile_no}}
                      </h5>
                  </div>
              </div>
              <div class="row" style="width: 20rem; justify-content: center; margin-top: 5px; margin-bottom: 5px;">
                  <center>
                      <qrcode-vue  :value="vc_data.uid" v-if="vc_data.uid" :size="55" level="H"></qrcode-vue>
                  </center>
              </div>
              <!-- <center>
                      <div class="barcode">
                          <barcode height="50" width="1" font-size="15px" v-model="vc_data.uid" v-bind:value="vc_data.uid"> </barcode>
                      </div>
                  </center> -->
          </div>
          <div class="row" style="background-color: white; height: 15px; position: relative; width: 316px;"></div>
      </div>
  </div>
</template>

<script>
  import axios from "axios";
  import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  import VueBarcode from "vue-barcode";
  import QrcodeVue from "qrcode.vue";

  export default {
      components: {
          barcode: VueBarcode,
          QrcodeVue,
      },
      data: () => ({
          snackbar_msg: "",
          basepath: null,
          color: "",
          snackbar: false,
          overlay: false,
          ///////////////////////////////////////////////
          ut: null,
          vc_data: null,
          org_basic_data: null,
          awspath: null,
      }),
      created() {
          this.ut = localStorage.getItem("EPS-ut");
          this.tenant = localStorage.getItem("EPS-tenant");
          this.awspath = localStorage.getItem("awspath");
      },
      mounted() {
        //   alert(this.ut)
          this.basepath = localStorage.getItem("awspath");

          axios
              .post("icard/virtualCard")
              .then((res) => {
                  if (res.data.flag == "YES") {
                      this.vc_data = res.data.vc_data;
                      this.org_basic_data = res.data.org_basic_data;
                      this.overlay = false;
                  } else {
                      this.showSnackbar("red", res.data.snackbar);
                      sessionStorage.setItem("error-trace", res.data.error_trace);
                      this.overlay = false;
                  }
                  this.overlay = false;
              })
              .catch((error) => {
                  this.onerror(error);

                  this.overlay = false;
              })
              .finally(() => {
                  this.overlay = false;
                  // this.selected_date=""
              });
      },
      methods: {
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          onerror(error) {
              let msg = "";
              if (error.response) {
                  msg = "Something went wrong.";
              } else if (error.request) {
                  msg = "Please try again.";
              } else {
                  msg = "Un-expected error.";
              }
              this.showSnackbar("error", msg);
          },
      },
  };
</script>

<style scoped>
  @media print {
      .pagebreak {
          page-break-before: always !important;
          height: 200px;
      }
      .no-display,
      .v-input__control,
      input[type="button"],
      input[type="submit"],
      input[type="reset"],
      #v-card {
          display: none !important;
      }

      @page {
          /* margin: 0mm; */
          margin: -1.2645833mm;
          /* size: 85mm 55mm; */
          size: 53mm 85mm;
      }
  }
  /* .icard {
margin-top: 5%;
width: 50%;
margin-left: 26%;
border: 4px solid purple;
} */
  .icard {
      border: 4px solid black;
      border-radius: 10px;
  }
  .trust-logo {
      height: 80%;
      width: 90%;
  }
  .adrs {
      text-align: center;
  }
  @media all and (max-width: 900px) {
      h2 {
          font-size: 12px;
      }
      h1 {
          font-size: 25px;
      }
      .trust-logo {
          height: 82%;
          width: 100%;
      }
      .adrs {
          margin-left: 1%;
          font-size: 13px;
      }
      .main-row {
          margin-top: -4%;
      }
  }
</style>
